import { useStaticQuery, graphql } from "gatsby"
export const usePrismBanner = () => {
const prismic = useStaticQuery(
    graphql`
        query {
            allPrismicHomepage {
                edges {
                node {
                    data {
                    body2 {
                        __typename
                        ... on PrismicHomepageBody2Banner {
                            items {
                                banner_image {
                                    url
                                    alt
                                    xs {
                                        alt
                                        url
                                    }
                                    sm {
                                        alt
                                        url
                                    }
                                    md {
                                        alt
                                        url
                                    }
                                    lg {
                                        alt
                                        url
                                    }
                                }
                                banner_title {
                                html
                                text
                                }
                                banner_subtitle {
                                html
                                text
                                }
                                banner_description {
                                text
                                }
                                banner_link_title {
                                    text
                                }
                                banner_url
                                made_in_mexico
                            }
                        }
                    }
                    }
                }
                }
            }
        }
    `
  );
// console.log('allPrismicBlog->',prismic.allPrismicBlog);
return prismic.allPrismicHomepage
        
}
